export default __webpack_public_path__ + "static/media/welcome.14133f58.png";